import axiosInstance from '../Config/axiosConfig';

export const loginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post(
      '/user/login',
      credentials
    );
    const {
      data: {
        data: { token, role, user },
        status,
      },
    } = response;
    return { token, role, user, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const loginAffiliate = async (credentials) => {
  console.log(credentials, 'credentials');
  try {
    const response = await axiosInstance.post(
      '/affiliate/login',
      credentials
    );
    const {
      data: {
        data: { token, role, user },
        status,
      },
    } = response;
    return { token, role, user, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};
export const sendAdminVerificationCode = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/reset/password',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error sending Verification code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const verifyAdminVerificationCode = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/user/verify/code',
      formData
    );
    console.log(response, 'response');
    if (!response.status) {
      throw new Error('Error verifiying code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const setNewAdminPassword = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/user/set/password',
      formData
    );

    if (!response.status) {
      throw new Error('Error verifiying code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};
// Mock implementation
// export const loginUser = async (credentials) => {
//   await new Promise(resolve => setTimeout(resolve, 500));
//   if (credentials.user_id === 'admin@gmail.com' && credentials.password === '123') {
//     return {
//       token: loginCredentials.token,
//       role: loginCredentials.role,
//       user: loggedInUser,
//       status: loginCredentials.status
//     };
//   }
//   throw new Error('Invalid credentials');
// };

// export const logoutUser = async () => {
//   try {
//     const response = await axiosInstance.post('/user-api/auth/logout');

//     if (!response.data.status) {
//       throw new Error('Error logging out', response);
//     }
//     // return { token, role, user, status }; // Assume this returns the user object
//   } catch (error) {
//     throw error.response
//       ? error.response.data
//       : { message: 'Unknown error occurred' };
//   }
// };

export const signUpUser = async (formData) => {
  try {
    const response = await axiosInstance.post('/user/signup', formData);

    const payload = response?.data;

    if (!payload?.status) {
      throw payload ?? { message: 'Error during signup' };
    }

    const token = payload?.data?.token;
    const user = payload?.data?.user;

    if (!token) {
      throw { message: 'Signup succeeded but no token was returned. Please try logging in.' };
    }

    return { token, user, status: payload.status };
  } catch (error) {
    throw error?.response?.data ?? error;
  }
};

export const sendVerificationCodeId = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/user-api/id-recovery/verify-email-user-id',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error sending Verification code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const verifyVerificationCodeId = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/user-api/id-recovery/verify-code-user-id',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error verifiying code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const sendVerificationCode = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/reset/password',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error sending Verification code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const verifyVerificationCode = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/verify/code',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error verifiying code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const setNewPassword = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/set/password',
      formData
    );

    if (!response.data.status) {
      throw new Error('Error verifiying code', response);
    }
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const setUserId = async (id) => {
  try {
    const { data } = await axiosInstance.get(
      `/user-api/auth/suggest-user-ids?user_id=${id}`
    );
    return data.detail; // Assume this returns success obj
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// Admin
// export const loginAdmin = async (credentials) => {
//   try {
//     const response = await axiosInstance.post(
//       '/admin-api/auth/login',
//       credentials
//     );
//     const {
//       data: {
//         detail: { token, role, user },
//         status,
//       },
//     } = response;
//     return { token, role, user, status }; // Assume this returns the user object
//   } catch (error) {
//     throw error.response
//       ? error.response.data
//       : { message: 'Unknown error occurred' };
//   }
// };

// export const logoutAdmin = async () => {
//   try {
//     const response = await axiosInstance.post('/admin-api/auth/logout');

//     if (!response.data.status) {
//       throw new Error('Error logging out', response);
//     }
//     // return { token, role, user, status }; // Assume this returns the user object
//   } catch (error) {
//     throw error.response
//       ? error.response.data
//       : { message: 'Unknown error occurred' };
//   }
// };

// Mock implementations for other functions
export const logoutUser = async () => {
  await new Promise(resolve => setTimeout(resolve, 500));
  return { status: true };
};

export const loginAdmin = async (credentials) => {
  try {
    const response = await axiosInstance.post(
      '/admin/login',
      credentials
    );
    const {
      data: {
        data: { token, role, user },
        status,
      },
    } = response;
    return { token, role, user, status }; // Assume this returns the user object
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};
// export const loginAdmin = async (credentials) => {
//   return loginUser(credentials); // Use the same mock for now
// };

export const logoutAdmin = async () => {
  return logoutUser(); // Use the same mock for now
};

export const logoutAffiliate = async () => {
  return logoutUser(); // Use the same mock for now
};